import React, { RefObject, useCallback, useEffect, useState } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';
import { featuresData } from '~/src/features/videocontrol/data';

import { customDotsStyles } from '~/src/features/videocontrol/styled';
import * as ST from './styled';

interface IFeaturesProps {
    videocontrolRef?: RefObject<HTMLHeadingElement | null>,
}

const Features = ({ videocontrolRef }: IFeaturesProps): JSX.Element => {
    const [onClientSide, setOnClientSide] = useState(isClientSide());

    useEffect(() => {
        setOnClientSide(isClientSide);
    }, []);

    const handleClick = useCallback(() => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.landing,
            action: ACTIONS.clickOnBtn,
            label: 'connect',
        });
        videocontrolRef?.current?.scrollIntoView({
            behavior: 'smooth',
        });
    }, [videocontrolRef]);

    return (
        onClientSide
            ? <ST.FeaturesContainer data-test='features-videocontrol-carousel'>
                <AdaptiveNukaCarousel
                    withoutArrows
                    desktopSlideWidth={'320px'}
                    cellSpacing={32}
                    slidesToScroll={'auto'}
                    customDotsStyles={customDotsStyles}
                    visibleSlides={{
                        desktop: 4,
                        sDesktop: 3,
                        laptop: 2,
                        mobile: 1,
                    }}
                    wrapAround={true}
                >
                    {featuresData?.map((elem) => {
                        const { id, png, webp, title, text } = elem;

                        return (
                            <ST.FeaturesBlock key={id}>
                                <ST.ImgBlock
                                    pngImg={png}
                                    webpImg={webp}
                                >
                                    <ST.TextBlock>
                                        <ST.Title>{title}</ST.Title>
                                        <ST.SubText>{text}</ST.SubText>
                                    </ST.TextBlock>
                                </ST.ImgBlock>
                            </ST.FeaturesBlock>
                        );
                    })}
                </AdaptiveNukaCarousel>
                <ST.Button onClick={handleClick} type={btnTypes.ACCENT}>Подключить</ST.Button>
            </ST.FeaturesContainer>
            : <ST.NoSsrContainer>
                {featuresData.map((elem) => {
                    const { id, png, webp, title, text } = elem;

                    return (
                        <ST.ImgBlock key={id}
                            pngImg={png}
                            webpImg={webp}
                        >
                            <ST.TextBlock>
                                <ST.Title>{title}</ST.Title>
                                <ST.SubText>{text}</ST.SubText>
                            </ST.TextBlock>
                        </ST.ImgBlock>
                    );
                })}
            </ST.NoSsrContainer>
    );
};

export default Features;
